namespace Solovis.Reports.Parameters {

    interface Investment {
        label: string;
        investmentId: number;
        resourceId: number;
    }
    interface Entity {
        label: string;
        entityId: number;
        resourceId: number;
    }

    export class EntityOrInvestmentExtendedSearchResultsDialog {

        public _query;
        public _dialogWindow: Solovis.UI.Dialog;

        constructor(options) {
            var self = this;

            this._query = options.query ? options.query : null;

            var desiredWidth = Math.min($(window).width() * .8, 600);
            var desiredHeight = Math.min($(window).height() * .8, 400);

            var minWidth = 100;
            var minHeight = 100;

            var editorDiv = $("<div>")
                .addClass("editordiv")
                .css("box-sizing", "content-box")
                .css("overflow", "hidden")
                .css("min-height", "75px");

            var extendedSearchResultsControl = new Solovis.Reports.Parameters.EntityOrInvestmentExtendedSearchResultsControl({
                controlHost: editorDiv,
                query: this._query,
                handleSelection: options.handleSelection,
            });

            $(extendedSearchResultsControl).on("selectionChanged", function () {
                self._dialogWindow.close();
            });

            extendedSearchResultsControl.setAsCurrentControl();

            this._dialogWindow = new Solovis.UI.Dialog({
                container: editorDiv,

                title: "More Results",

                modal: true,
                center: true,
                actions: ["Close"],
                autoOpen: true,
                destroyOnClose: true,
                width: desiredWidth,
                minWidth: minWidth,
                minHeight: minHeight,
                height: desiredHeight,
                noPaddingOnContent: true,

                resize: function () {
                    var overallHeight = this.getAvailableContentHeight();
                    extendedSearchResultsControl.setAvailableHeight(overallHeight);
                },

                activate: function () {
                    var overallHeight = this.getAvailableContentHeight();
                    extendedSearchResultsControl.setAvailableHeight(overallHeight);
                    extendedSearchResultsControl.focusFilter();
                },

                close: options.handleClose

            });
        }

        public static showDialog(options) {
            var dialog = new Solovis.Reports.Parameters.EntityOrInvestmentExtendedSearchResultsDialog(options);
        }
    }

    export class EntityOrInvestmentExtendedSearchResultsControl extends Solovis.UI.BaseControl {

        public _query: any;
        public _itemToggles: any;
        public _showAll: boolean;
        public _extendedSearchResultsData: any;
        public _initErrorText: any;

        public _filterListControl: Solovis.UI.StringFilterListControl;

        private _focusAfterRender: boolean;

        private _toggleButtonGroupContainerDiv;
        private _availableHeight;

        private _handleSelection;

        constructor(options) {
            super(options);

            var self = this;

            if (!options.query) {
                throw "Solovis.Reports.Parameters.EntityOrInvestmentExtendedSearchResultsControl Missing Parameter: query";
            }

            this._query = options.query;

            if (!options.handleSelection) {
                throw "Solovis.Reports.Parameters.EntityOrInvestmentExtendedSearchResultsControl Missing Parameter: handleSelection";
            }

            this._handleSelection = options.handleSelection;


            this._itemToggles = {
                showInvestments: false,
                showEntities: false
            };

            this._showAll = true;

            this._focusAfterRender = false;
        }


        public doInitAsync() {
            var self = this;

            var options = {
                query: { filterText: this._query.filterText },
                offset: 0,
                maxItems: Solovis.Site.Search.maxItemsInExtendedSearchResultsDialog
            };

            Solovis.Rpc.invoke("~/Search/FindItems", options,
                function (response, success) {
                    if (success) {
                        self._extendedSearchResultsData = response.result.data;
                        self.notifyInitComplete();
                    }
                    else {
                        self._initErrorText = response.error.message;
                        self.notifyInitComplete();
                    }
                });
        }

        public doRender() {
            var self = this;

            if (this._initErrorText) {
                this.container.text(this._initErrorText);
                return;
            }

            this._createToggleButtons();

            var itemFilter = function (itemList, filterOptions) {
                var resultList = [];

                var queryTextLower = filterOptions.queryText.toLowerCase();

                $(itemList).each(function (index, item: any) {

                    if ((self._showAll && item.entityId || item.investmentId) ||
                        self._itemToggles.showEntities && item.entityId ||
                        self._itemToggles.showInvestments && item.investmentId) {
                        var labelLower = item.label.toLowerCase();
                        var labelMatch = labelLower.indexOf(queryTextLower);


                        if (labelMatch !== -1) {
                            resultList.push({
                                isPrefix: labelMatch === 0,
                                item: item,
                                labelLower: labelLower
                            });
                        }
                    }
                });

                return resultList;
            }

            var itemDivGenerator = function (itemHolder, filterOptions) {
                var itemDiv = $("<div>")
                    .css({
                        "white-space": "nowrap",
                        "overflow": "hidden",
                        "text-overflow": "ellipsis"
                    })
                    .text(itemHolder.item.label);

                if (itemHolder.item.entityId) {
                    Solovis.UI.Icons.createEntityIcon({ "padding-right": "10px" }).prependTo(itemDiv);
                }
                else if (itemHolder.item.investmentId) {
                    Solovis.UI.Icons.createInvestmentIcon({
                        "left": "-2px",
                        "padding-right": "4px"
                    })
                        .prependTo(itemDiv);
                }
                else {
                    // If none of these conditions are true, just add a transparent spacer so things line up
                    $("<span>")
                        .css("padding-right", "10px")
                        .css("color", "transparent")
                        .addClass("fa fa-circle").prependTo(itemDiv);
                }

                return itemDiv;
            }

            var selectorControlHostDiv = $("<div>")
                .addClass("solovis-input")
                .appendTo(this.container);

            this._filterListControl = new Solovis.UI.StringFilterListControl({
                controlHost: selectorControlHostDiv,
                listItems: this._extendedSearchResultsData,
                listFilter: itemFilter,
                itemDivGenerator: itemDivGenerator
            });

            $(this._filterListControl)
                .on("selectionChanged", function (e, data) {
                    var selectedItem = data.item;
                    self._handleSelection(selectedItem);
                    $(self).trigger("selectionChanged");
                });

            this._filterListControl.setAsCurrentControl();
            // NOTE: set the input to the initial filter text
            this._filterListControl._filterInput._filterQueryInput.val(this._query.filterText);

            if (this._focusAfterRender) {
                this.focusFilter();
            }
        }

        public _createToggleButtons() {
            var self = this;

            this._toggleButtonGroupContainerDiv = $("<div>")
                .css("padding", "5px")
                .addClass("btn-group")
                .attr("data-toggle", "buttons")
                .appendTo(this.container);

            // #region Toggle Entities
            var entitiesButtonLabel = ($("<label>") as any)
                .solovisTooltip({
                    text: "Toggle Entities"
                })
                .addClass("btn btn-primary btn-xs")
                .appendTo(this._toggleButtonGroupContainerDiv);

            Solovis.UI.Icons.createEntityIcon()
                .appendTo(entitiesButtonLabel);

            var entitiesCheckbox = $("<input>")
                .attr("type", "checkbox")
                .change(function () {
                    self._itemToggles.showEntities = entitiesCheckbox.is(":checked");
                    self._applyFilter();
                })
                .appendTo(entitiesButtonLabel);
            // #endregion

            // #region Toggle Investments
            var investmentsButtonLabel = ($("<label>") as any)
                .css("padding", "1px")
                .solovisTooltip({
                    text: "Toggle Investments"
                })
                .addClass("btn btn-primary btn-xs")
                .appendTo(this._toggleButtonGroupContainerDiv);

            Solovis.UI.Icons.createInvestmentIcon().appendTo(investmentsButtonLabel);

            var investmentsCheckbox = $("<input>")
                .attr("type", "checkbox")
                .change(function () {
                    self._itemToggles.showInvestments = investmentsCheckbox.is(":checked");
                    self._applyFilter();
                })
                .appendTo(investmentsButtonLabel);
            // #endregion
        }

        public _applyFilter() {
            var self = this;

            this._showAll =
                _.all(this._itemToggles, function (value) { return value === true; }) ||
                _.all(this._itemToggles, function (value) { return value === false; });

            this._filterListControl._listDisplay.filter();
        }

        public setAvailableHeight(overallHeight) {
            var self = this;
            var availableHeight = overallHeight;

            if (this._toggleButtonGroupContainerDiv) {
                availableHeight = overallHeight - this._toggleButtonGroupContainerDiv.outerHeight();
            }

            if (this.state === Solovis.UI.BaseControl.ControlState.afterRender) {
                this._filterListControl.setAvailableHeight(availableHeight);
            }
            else {
                // The control is still rendering, so we will store the overallHeight and defer until the render is complete
                this._availableHeight = availableHeight;
            }
        }

        public focusFilter() {
            if (this._filterListControl) {
                this._filterListControl.focusFilter();
                this._focusAfterRender = false;
            }
            else {
                this._focusAfterRender = true;
            }
        }
    }


}
